import React from 'react'
import { Updatable } from '../components/Updatable/Updatable'

export type UpdatableReactElement = {
    element: React.ReactElement
    updater: {
        forceUpdate: () => void
    }
}

export const createReactElement = <T extends object>(
    component: React.FC<T>,
    props: T
): UpdatableReactElement => {
    const res: { updater: { forceUpdate: () => void }; element: React.ReactElement } = {
        updater: { forceUpdate: () => {} },
        element: <></>,
    }
    return {
        element: (
            <Updatable
                setUpdatableResult={result => {
                    res.updater.forceUpdate = result.forceUpdate
                    res.element = result.element
                }}
                component={component}
                props={props}
            />
        ),
        updater: res.updater,
    }
}

export const clsx = (...args: (string | undefined)[]) => args.filter(Boolean).join(' ')
